import React from 'react';
import { withStyles } from '@material-ui/core';
import { Button, IconArrow } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import styles from './styles';
import upgradeVps from '@/media/hostingAndServers/upgrade-vps.png';
import upgradeVpsMobile from '@/media/hostingAndServers/upgrade-vps-mobile.png';
import { useSelector } from 'react-redux';

const ChangePlanVpsOciCard = ({
  classes,
  locales,
  onGoToChangePlanPage,
  fullWidth = true,
}) => {
  const vpsOci = useSelector(state => state.vpsOci);
  const { addons } = (vpsOci && vpsOci.data) || {};

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  const handleGoToChangePlanPage = () => {
    onGoToChangePlanPage && onGoToChangePlanPage();
  };

  if (!addons || addons.length > 0) return null;

  const cardClassName = fullWidth ? `${classes.card} ${classes.cardFullWidth}` : classes.card;

  return (
    <div className={cardClassName}>
      <div className={classes.content}>
        <div className={classes.blockText}>
          <h3 className={classes.title}>{locales.title}</h3>
          <p className={classes.description}>{locales.description}</p>

          <div className={classes.actions}>
            <Button
              onClick={handleGoToChangePlanPage}
              testId="vpsoci-change-plan-card-button"
              label={locales.buttonLabel}
              variant="primary"
              size="large"
              width={isMobile ? 'full' : 'fit-content'}
              iconRight={<IconArrow direction="right" />}
              version="v2"
            />
          </div>
        </div>
        <div className={classes.blockImage}>
          <img src={isMobile ? upgradeVpsMobile : upgradeVps} alt={locales.title} className={classes.Image} />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(ChangePlanVpsOciCard);
